module.exports = __webpack_public_path__ + "img/vip4.2dc3edce.png";